import React, { Fragment } from "react";
import { Modal, Button } from "react-bootstrap";
import check from "../../../../assets/check.png";
import "./modal.scss";

const TimeRangeModal = ({ okayClickHandler, title,procedure }) => {

  function ReplaceConsultationType(messaage){
    if(messaage.includes("0")){
      return (messaage.replace("consultation type 0",procedure))
    }
    else if(messaage.includes("1")){
      return (messaage.replace("consultation type 1",procedure))
    }
    else if(messaage.includes("5")){
      return (messaage.replace("consultation type 5",procedure))
    }
    else if(messaage.includes("6")){
      return (messaage.replace("consultation type 6",procedure))
    }
    else{
      return messaage;
    }
  }

  return (
    <div className="myschedule-modal">
      <div className="text-center align-items-center">
        <img
          src={check}
          alt="Success"
          style={{ width: "60px", height: "60px" }}
        />
        <p className="font-weight-bold my-1 modal-heading">
          Time Slots added successfully
        </p>
        {/* {procedure ? ( */}
        {
          title !=""?<p>
            {ReplaceConsultationType(title)}
          </p>:
          <p className="mt-2 mb-3 modal-paragraph">
          Selected time slot will be opened up for <b>{procedure}</b> appointments
        </p>
        }
          {/* <p className="mt-2 mb-3 modal-paragraph">
            Selected time slot will be opened up for <b>{procedure}</b> appointments
          </p> */}
        {/* ) : (
          <p className="mt-2 mb-3 modal-paragraph">
            Selected time slot will be automatically opened up for both regular
            and follow up appointments
          </p>
        )} */}
      </div>
      <div className="d-flex flex-column justify-content-center align-items-center">
        <Button
          className="border-0 rounded-pill "
          style={{
            backgroundColor: "#17BAE0",
            color: "#fff",
            width: "140px",
            height: "44px",
          }}
          onClick={okayClickHandler}
        >
          Okay
        </Button>
      </div>
    </div>
  );
};

export default TimeRangeModal;
